export default "__VITE_ASSET__CEHWKJ$x__"